export const PERMISSIONS = {
  PRONTUARIO_VIEW: 'PRONTUARIO_VIEW',
};

const PERMISSION_DENIED_MESSAGES = {
  [PERMISSIONS.PRONTUARIO_VIEW]: 'Você não tem permissão para acessar o prontuário eletrônico.',
};

const FUNC_PERMISSIONS = {
  [PERMISSIONS.PRONTUARIO_VIEW]: ['90000', '90011', '90021'],
};

function normalizeCode(value) {
  if (value === null || value === undefined) return '';
  return String(value).trim();
}

export function hasPermission({ doctor, func, patient, permission }) {
  if (!permission) return true;

  if (permission === PERMISSIONS.PRONTUARIO_VIEW) {
    if (doctor) {
      return doctor.tipo !== 'Externo';
    }

    if (func) {
      const codFunc = normalizeCode(func.codFunc);
      const allowedCodes = FUNC_PERMISSIONS[PERMISSIONS.PRONTUARIO_VIEW] || [];
      return allowedCodes.includes(codFunc);
    }

    if (patient) {
      return false;
    }

    return false;
  }

  return false;
}

export function getPermissionDeniedMessage(permission) {
  return (
    PERMISSION_DENIED_MESSAGES[permission] || 'Você não tem permissão para acessar esta página.'
  );
}
